import instanceAxios from "../config/config";
import { AxiosResponse } from "axios";

interface DeckListParams {
    page?: number;
    limit?: number;
    search?: string;
}

interface Category {
    _id: string;
    title: string;
    numOfDecks: number;
    type: string;
    image: string;
    createdAt: string;
    updatedAt: string;
}

interface CategoriesListResponse {
    categories: Category[];
    count: number;
}

interface CategoriesGetOneResponse {
    status: number;
    category: Category;
}

const BASE_URL = `/category`;

const CategoriesService = {
    getCategories: (params?: DeckListParams): Promise<AxiosResponse<CategoriesListResponse>> => {
        return instanceAxios.get(`${BASE_URL}/listForAdmin`, {
            params: {
                page: params?.page ?? 1,
                limit: params?.limit ?? 10,
                search: params?.search ?? "",
            },
        });
    },

    createCategory: (data: { title: string }): Promise<AxiosResponse> => {
        return instanceAxios.post(`${BASE_URL}/create`, data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },

    deleteCategory: (id: string): Promise<AxiosResponse> => {
        return instanceAxios.delete(`${BASE_URL}/${id}`);
    },

    updateCategory: (id: string, data: { title: string }): Promise<AxiosResponse> => {
        return instanceAxios.put(`${BASE_URL}/${id}`, data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },

    getOneCategory: (id: string): Promise<AxiosResponse<CategoriesGetOneResponse>> => {
        return instanceAxios.get(`${BASE_URL}/${id}`);
    }
};

export default CategoriesService;